import { render, staticRenderFns } from "./FGBreadHead.vue?vue&type=template&id=71a4e355&scoped=true"
import script from "./FGBreadHead.vue?vue&type=script&lang=js"
export * from "./FGBreadHead.vue?vue&type=script&lang=js"
import style0 from "./FGBreadHead.vue?vue&type=style&index=0&id=71a4e355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a4e355",
  null
  
)

export default component.exports